import Head from 'next/head';
import { Footer, Header } from '../../components';
import HeraPage from './hera-page';

import previewHera from '../../public/preview/preview-hera.png';
import menu from '../../utils/menu';

export default function Hera() {
  return (
    <>
      <Head>
        <title>Hera: Empowering Businesses with Customized ERP Solutions</title>
        <meta
          property="og:title"
          content="Hera: Empowering Businesses with Customized ERP Solutions"
        />
        <meta property="og:image" content={`${previewHera.src}`} />
        <meta name="twitter:image" content={`${previewHera.src}`} />
        <meta
          property="og:image:alt"
          content="Hera: Empowering Businesses with Customized ERP Solutions"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="Hera, a bespoke ERP system, streamlines and optimizes business processes. Hera helps organizations manage inventory, order processing, finance, HR, and more. Hera improves operational efficiency, data quality, and decision-making via real-time analytics and reporting. Integrate seamlessly with current systems and customize to match your organization's requirements. Hera, Mavinx's ERP system, maximizes corporate potential."
        />
        <meta
          name="description"
          content="Hera, a bespoke ERP system, streamlines and optimizes business processes. Hera helps organizations manage inventory, order processing, finance, HR, and more. Hera improves operational efficiency, data quality, and decision-making via real-time analytics and reporting. Integrate seamlessly with current systems and customize to match your organization's requirements. Hera, Mavinx's ERP system, maximizes corporate potential."
        />
        <meta
          name="keywords"
          content="Hera, Enterprise Resource Planning, ERP solution, business process optimization, inventory management, order processing, finance, human resources, operational efficiency, data accuracy, informed decision-making, real-time analytics, reporting, system integration, customization options, business potential, Mavinx ERP solution"
        />
      </Head>
      <Header appearance="transparent" appearanceLogo="white" menu={menu} />
      <HeraPage />
      <Footer />
    </>
  );
}
